import { Link as RouterLink, NavLink as RouterNavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Languages reachable via URL prefix: /es, /pt, ... (English stays unprefixed at /)
export const LANG_SLUGS = ["es", "pt", "de", "fr", "it", "ru", "fi", "no", "ja", "ar"];

const NO_PREFIX_PATHS = ["/admin", "/activate", "/zoho-connect"];

export function stripLangPrefix(pathname) {
  const seg = pathname.split("/")[1] || "";
  if (LANG_SLUGS.includes(seg)) {
    return pathname.slice(seg.length + 1) || "/";
  }
  return pathname;
}

export function useLangPrefix() {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "en").split("-")[0];
  return LANG_SLUGS.includes(lang) ? `/${lang}` : "";
}

export function applyLangPrefix(to, prefix) {
  if (typeof to !== "string" || !to.startsWith("/") || to.startsWith("//")) return to;
  if (NO_PREFIX_PATHS.some((p) => to === p || to.startsWith(`${p}/`) || to.startsWith(`${p}?`))) return to;
  const hashIndex = to.indexOf("#");
  const path = hashIndex >= 0 ? to.slice(0, hashIndex) : to;
  const hash = hashIndex >= 0 ? to.slice(hashIndex) : "";
  if (!prefix) return `${path}${hash}`;
  return `${prefix}${path === "/" ? "" : path}${hash}`;
}

export function Link({ to, ...props }) {
  const prefix = useLangPrefix();
  return <RouterLink to={applyLangPrefix(to, prefix)} {...props} />;
}

export function NavLink({ to, end, ...props }) {
  const prefix = useLangPrefix();
  const url = applyLangPrefix(to, prefix);
  // The prefixed home target (e.g. /es) is not the router root, so it must be
  // marked `end` or it would stay active on every sub-page.
  return <RouterNavLink to={url} end={to === "/" ? true : end} {...props} />;
}

export function useLangNavigate() {
  const navigate = useNavigate();
  const prefix = useLangPrefix();
  return (to, options) => navigate(applyLangPrefix(to, prefix), options);
}
